import type { ForgotPasswordFormValues } from './schemas';

import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';

import { useToast } from '@paid-ui/ui/toast';
import { request } from '@paid-ui/utils/axios';

import { forgotPasswordSchema } from './schemas';

export type ForgotPasswordBody = ForgotPasswordFormValues;

export const useForgotPasswordForm = () => {
  return useForm({
    mode: 'onSubmit',
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      account: '',
    },
  });
};

export const useForgotPassword = () => {
  const toast = useToast();

  return useMutation({
    mutationKey: ['ForgotPassword'],
    mutationFn: async (formValues: ForgotPasswordBody) => {
      const { data } = await request.post<null>('/validate/send-reset-password-email', formValues);
      return data;
    },
    onSuccess() {
      toast.success('If your email address has a Paid account we will send you an email.');
    },
    onError(err) {
      toast.error(err instanceof Error ? err.message : 'Failed to send reset password email.');
    },
  });
};
